import React from 'react';
import {Field} from "formik";
import {makeStyles,} from "@material-ui/core";
import Multiselectinput from '../../components/formikcomponent/MutiSelectinput';
const DrugCategory = (props) => {
  const useStyles = makeStyles(() => ({
    createUserSelect: {
      "& p": {
        maxWidth: "200px", textOverflow: "ellipsis",
        display: "inline-block", overflow: "hidden", whiteSpace: "nowrap !important",
      }
    }
  }));
const classes = useStyles();
return(
  <Field
    name="trigger"
    options={props.triggeroptions}
    component={Multiselectinput}
    placeholder="Triggers "
    variant="filled"
    label="Triggers *"
    className={classes.inputItem}
    className={classes.createUserSelect + " " + "selectstyle"}
    menuPortalTarget={document.body}
    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
  />
);
};
export default DrugCategory;